/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function RefinanciamentoFinanciamentoSantanderRedirect() {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/renegociacao-santander-financiamentos.html`);
  }, []);
  return <>{/*  */}</>;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default RefinanciamentoFinanciamentoSantanderRedirect;
